import React, { useMemo } from 'react'
import { Trans } from 'react-i18next'

import { BuilderDialog } from '@makyoapp/makyo-common'
import { Dialog16 } from '@makyoapp/makyo-icon/icon'
import { SelectDropdown } from '@makyoapp/makyo-ui'

import { useAppBuilderContext } from '@/context/AppBuilderContext'

export function DialogSelectV2({
  id,
  value,
  onChange,
  excludes = [],
  portal = true,
}: {
  id?: string
  value?: string
  onChange: (value: string) => void
  excludes?: string[]
  portal?: boolean
}) {
  const { dialogs } = useAppBuilderContext()

  const options = useMemo(() => {
    return excludes.length > 0 ? dialogs.filter(({ id }) => !excludes.includes(id)) : dialogs
  }, [dialogs, excludes])

  return (
    <SelectDropdown
      id={id}
      value={dialogs.find(({ id }) => id === value)}
      onChange={(opt, e) => {
        e.preventDefault()
        e.stopPropagation()
        onChange(opt.id)
      }}
      portalMenu={portal}
      //toggleClassName='dark:[&:not(:hover)]:bg-slate-800!'
      menuFullWidth={!portal}
      menuZIndex='z-20'
      menuContainerClassName={!portal ? '' : 'mk-ag-sdd'}
      options={[{ id: '', name: 'Select Dialog' } as BuilderDialog, ...options]}
      optionLabel={(opt) => `${opt?.id} ${opt?.name}`}
      renderOption={(opt) => {
        return (
          <div className='flex-c'>
            <Dialog16 />
            <div>{opt?.id === '' ? <Trans>{opt?.name}</Trans> : opt?.name}</div>
          </div>
        )
      }}
    />
  )
}
